<template>
  <div class="places__map">
    <div id="leaflet-map"></div>
  </div>
</template>

<script>
import L from 'leaflet'

export default {
  name: 'PlacesMap',
  props: ['places', 'selectedType', 'focusedPlace'],
  data () {
    return {
      placesMap: null,
      pointLayer: null,
      allMarkers: {},
      activeMapIcon: null,
      darkMapIcon: null
    }
  },
  watch: {
    places () {
      this.setMapPoints()
    },
    selectedType () {
      this.setMapPoints()
    },
    focusedPlace (place) {
      this.focusPlace(place)
    }
  },
  mounted () {
    this.placesMap = L.map('leaflet-map').setView([47.0355841,8.2924322], 13.5)
    this.placesMap.scrollWheelZoom.disable()
    this.placesMap.once('focus', function() { this.placesMap.scrollWheelZoom.enable() })

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.placesMap)

    this.activeMapIcon = L.divIcon({
      className: 'leaflet-map-icon-active',
      iconSize:     [25, 25],
      iconAnchor:   [12, 12],
    })
    this.darkMapIcon = L.divIcon({
      className: 'leaflet-map-icon-dark',
      iconSize:     [20, 20],
      iconAnchor:   [10, 10],
    })

    this.pointLayer = L.layerGroup().addTo(this.placesMap);
    this.setMapPoints()
  },
  methods: {
    setMapPoints () {
      this.pointLayer.clearLayers()
      for (let place of this.places) {
        let icon = (this.selectedType == place.data.type ? this.activeMapIcon : this.darkMapIcon)
        let marker = L.marker([place.data.position.latitude, place.data.position.longitude], {icon: icon}).addTo(this.pointLayer)
        marker.bindPopup(`
          <div class="places__list-item">
            <h3>${place.data.name[0].text}</h3>
            <p>${place.data.description[0] ? place.data.description[0].text : ''}</p>
          </div>
        `)
        this.allMarkers[place.data.name[0].text] = marker
      }
    },
    focusPlace (place) {
      let marker = this.allMarkers[place.data.name[0].text]
      let latLngs = [ marker.getLatLng() ]
      let markerBounds = L.latLngBounds(latLngs)
      this.placesMap.fitBounds(markerBounds)
      marker.openPopup()
    }
  }
}
</script>